/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import SVG from "react-inlinesvg";
import { ModalProgressBar } from "../../../_themeBase/_partials/controls";
import { ShowToast, toAbsoluteUrl, ToastType } from "../../../_themeBase/_helpers";
import * as auth from "../Auth";
import { changePassword, logout } from "../Auth/_redux/authCrud";

function ProfileChangePassword(props) {
  // Fields
  const { intl } = props;
  const [loading, setloading] = useState(false);
  const [isError, setisError] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user, shallowEqual);
  useEffect(() => { }, [user]);
  // Methods


  const saveUser = (values, setStatus, setSubmitting) => {
    setloading(true);
    setisError(false);
    // const updatedUser = Object.assign(user, {
    //   newPassword: values.newPassword,
    // });
    // // user for update preparation
    // dispatch(props.setUser(updatedUser));

    // const userLocal = JSON.parse(sessionStorage.authUser);

    changePassword(user.username, values["oldPassword"], values["newPassword"])
      .then(() => {
        setloading(false);
        // window.localStorage.clear()
        // window.sessionStorage.clear()
        // window.location.replace("/auth/login");
        ShowToast("رمز عبور با موفقیت تغییر کرد. لطفا با رمز جدید وارد شوید.", ToastType.success, 10000);
        logout()
          .then((res) => {
            props.logout();
          })
          .catch((err) => {
            window.localStorage.clear();
            window.sessionStorage.clear();
            window.location.replace("/auth/login");
          });
      })
      .catch((error) => {
        setloading(false);
        setSubmitting(false);
        setisError(true);
        if (error.response) {
          setStatus(error.response.data.Message);
        }
        else {
          setStatus("اجرای عملیات با مشکل مواجه شد. دوباره تلاش کنید");
        }

      });

  };
  // UI Helpers
  const initialValues = {
    oldPassword: "",
    newPassword: "",
    rePassword: "",
  };
  const Schema = Yup.object().shape({
    oldPassword: Yup.string().required("پر کردن فیلد الزامی است"),
    newPassword: Yup.string().required("پر کردن فیلد الزامی است"),
    rePassword: Yup.string()
      .required("پر کردن فیلد الزامی است")
      .when("newPassword", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("newPassword")],
          "تکرار رمز عبور با رمز عبور جدید مطابق نیست."
        ),
      }),
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveUser(values, setStatus, setSubmitting);
    },
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });

  return (
    <form className="card card-custom" onSubmit={formik.handleSubmit}>
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            تغییر رمز
          </h3>
          <span className="text-muted font-weight-bold font-size-sm mt-1">
            رمز کاربری خود را تغییر دهید
          </span>
        </div>
        <div className="card-toolbar">
          <button
            type="submit"
            className="btn btn-primary mr-2"
            disabled={
              formik.isSubmitting || (formik.touched && !formik.isValid)
            }
          >
            ذخیره
            {formik.isSubmitting}
          </button>
          {/* <Link
            to="/user-profile/profile-overview"
            className="btn btn-secondary"
          >
            انصراف
          </Link> */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Form */}
      <div className="form">
        <div className="card-body">
          {/* begin::Alert */}
          {formik.status && isError && (
            <div
              className="alert alert-custom alert-light-danger fade show mb-10"
              role="alert"
            >
              <div className="alert-icon">
                <span className="svg-icon svg-icon-3x svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}
                  ></SVG>{" "}
                </span>
              </div>
              <div className="alert-text font-weight-bold">
                {formik.status}
              </div>
              <div className="alert-close" onClick={() => setisError(false)}>
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <i className="ki ki-close"></i>
                  </span>
                </button>
              </div>
            </div>
          )}
          {/* end::Alert */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              رمز فعلی
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="رمز عبور فعلی خود را وارد نمایید"
                className={`form-control form-control-lg form-control-solid mb-2 ${getInputClasses(
                  "oldPassword"
                )}`}
                name="oldPassword"
                {...formik.getFieldProps("oldPassword")}
              />
              {formik.touched.oldPassword &&
                formik.errors.oldPassword ? (
                <div className="invalid-feedback">
                  {formik.errors.oldPassword}
                </div>
              ) : null}
              {/* <a href="#" className="text-sm font-weight-bold">
                آیا رمز عبور خود را فراموش کرده اید؟
              </a> */}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              رمز جدید
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="رمز جدید (حداقل 3 کاراکتر)"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "newPassword"
                )}`}
                name="newPassword"
                {...formik.getFieldProps("newPassword")}
              />
              {formik.touched.newPassword && formik.errors.newPassword ? (
                <div className="invalid-feedback">{formik.errors.newPassword}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              تکرار رمز جدید
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="تکرار رمز جدید باید با رمز جدید یکی باشد"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "rePassword"
                )}`}
                name="rePassword"
                {...formik.getFieldProps("rePassword")}
              />
              {formik.touched.rePassword && formik.errors.rePassword ? (
                <div className="invalid-feedback">
                  {formik.errors.rePassword}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {/* end::Form */}
    </form>
  );
}

export default connect(null, auth.actions)(ProfileChangePassword);
